var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 44H36V40C36 38.4087 35.3679 36.8826 34.2426 35.7574C33.1174 34.6321 31.5913 34 30 34H18C16.4087 34 14.8826 34.6321 13.7574 35.7574C12.6321 36.8826 12 38.4087 12 40V44H8V40C8 37.3478 9.05357 34.8043 10.9289 32.9289C12.8043 31.0536 15.3478 30 18 30H30C32.6522 30 35.1957 31.0536 37.0711 32.9289C38.9464 34.8043 40 37.3478 40 40V44ZM24 26C22.4241 26 20.8637 25.6896 19.4078 25.0866C17.9519 24.4835 16.629 23.5996 15.5147 22.4853C14.4004 21.371 13.5165 20.0481 12.9134 18.5922C12.3104 17.1363 12 15.5759 12 14C12 12.4241 12.3104 10.8637 12.9134 9.4078C13.5165 7.95189 14.4004 6.62902 15.5147 5.51472C16.629 4.40042 17.9519 3.5165 19.4078 2.91345C20.8637 2.31039 22.4241 2 24 2C27.1826 2 30.2348 3.26428 32.4853 5.51472C34.7357 7.76515 36 10.8174 36 14C36 17.1826 34.7357 20.2348 32.4853 22.4853C30.2348 24.7357 27.1826 26 24 26ZM24 22C26.1217 22 28.1566 21.1571 29.6569 19.6569C31.1571 18.1566 32 16.1217 32 14C32 11.8783 31.1571 9.84344 29.6569 8.34315C28.1566 6.84285 26.1217 6 24 6C21.8783 6 19.8434 6.84285 18.3431 8.34315C16.8429 9.84344 16 11.8783 16 14C16 16.1217 16.8429 18.1566 18.3431 19.6569C19.8434 21.1571 21.8783 22 24 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona);
export default __webpack_public_path__ + "static/media/persona.e8e574cf6ba63314650022bccc991c09.svg";
export { ForwardRef as ReactComponent };